var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "marketing-preferences-attributes-table" },
    [
      _c(
        "div",
        { staticClass: "marketing-preferences-attributes-table__header" },
        [
          _c("MarketingPreferencesAttributesSettingsHeader", {
            attrs: {
              filters: _vm.filters,
              searchable: true,
              searchValue: _vm.searchValue
            },
            on: {
              removeActiveFilters: _vm.filterAttributes,
              updateFilter: _vm.filterAttributes,
              search: _vm.searchAttributes
            }
          }),
          _vm._v(" "),
          !_vm.isEmptyList && !_vm.isLoading
            ? _c("CompassCheckbox", {
                staticClass:
                  "marketing-preferences-attributes-table__table-header-select-all",
                attrs: {
                  modelValue: _vm.$t.__("common.actions.select_all"),
                  checked: _vm.isAllItemsChecked,
                  indeterminate: _vm.isIndeterminateCheckAllItems
                },
                on: { change: _vm.checkAllItems }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.isLoading
        ? _c("TableLoading")
        : _c(
            "CompassTable",
            {
              staticClass: "marketing-preferences-attributes-table__table",
              attrs: { size: "medium" }
            },
            [
              _c(
                "CompassTableBody",
                [
                  _vm.isEmptyList
                    ? _c(
                        "template",
                        { slot: "empty" },
                        [
                          _c(
                            "CompassEmptyState",
                            {
                              attrs: {
                                illustrationPath:
                                  "/ressources/logged/img/illustrations/no-results.svg",
                                title: _vm.$t.__(
                                  "marketing.preferences.attributes.MarketingPreferencesAttributesTable.no_result"
                                )
                              }
                            },
                            [
                              _c("CompassButton", {
                                attrs: {
                                  label: _vm.$t.__("common.actions.reset")
                                },
                                on: { click: _vm.resetFiltersAndSearch }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.displayableAttributes, function(row) {
                    return _c(
                      "CompassTableRow",
                      {
                        key: "table-row--" + (row.id ? row.id : row.code),
                        attrs: { subhead: _vm.isSubhead(row) }
                      },
                      [
                        _vm.isSubhead(row)
                          ? _c("template", { slot: "subhead" }, [
                              _c("span", [
                                _vm._v(" " + _vm._s(row.label) + " ")
                              ])
                            ])
                          : [
                              _c("CompassTableBodyCell", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "marketing-preferences-attributes-table__table-container"
                                  },
                                  [
                                    _c(
                                      "CompassTooltip",
                                      {
                                        attrs: {
                                          content: _vm.$t.__(
                                            "marketing.preferences.attributes.MarketingPreferencesAttributesTab.default_synchronized_field"
                                          ),
                                          disabled: !row.default,
                                          placement: "bottom-start"
                                        }
                                      },
                                      [
                                        _c("CompassCheckbox", {
                                          attrs: {
                                            modelValue: row.label,
                                            showLabel: false,
                                            checked:
                                              row.synchronized || row.default,
                                            disabled: row.default
                                          },
                                          on: {
                                            change: function(value) {
                                              row.synchronized = value
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "typographies-paragraph-medium-regular"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(row.label) +
                                            "\n                            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                      ],
                      2
                    )
                  })
                ],
                2
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }